import axios from 'axios';
import { API_URL } from "../constant/Constant";

const AdminService = {
    getTrainers: async (accessToken, activeFilter) => {
        const response = await axios.get(`${API_URL}admin/trainer`,{
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'activeFilter': activeFilter
            }
        });
        return response;
    },

    addTrainer: async (accessToken, trainerData) => {
        const response = await axios.post(`${API_URL}admin/trainer`, trainerData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    updateTrainer: async (accessToken, trainerData) => {
        const response = await axios.put(`${API_URL}admin/trainer`, trainerData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    getSessionStatus: async (accessToken) => {
        const response = await axios.get(`${API_URL}admin/session-status`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },
    getSessionList: async (accessToken, activeFilter, startDate, endDate) => {
        const response = await axios.get(`${API_URL}admin/session`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'activeFilter': activeFilter,
                'startDate': startDate,
                'endDate': endDate
            }
        });
        return response;
    },

    getSession: async (accessToken, sessionId) => {
        const response = await axios.get(`${API_URL}admin/session/${sessionId}`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    getGroupedSessions: async (accessToken) => {
        const response = await axios.get(`${API_URL}admin/session/grouped`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    addSession: async (accessToken, sessionData) => {
        const response = await axios.post(`${API_URL}admin/session`, sessionData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    updateSession: async (accessToken, sessionData) => {
        const response = await axios.put(`${API_URL}admin/session`, sessionData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    getCustomers: async (accessToken, startDate, endDate) => {
        const response = await axios.get(`${API_URL}admin/customer`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'startDate': startDate,
                'endDate': endDate
            }
        });
        return response;
    },

    deactivateCustomer: async (accessToken, customerId) => {
        const response = await axios.put(`${API_URL}admin/customer/${customerId}/deactivate`, null, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    activateCustomer: async (accessToken, customerId) => {
        const response = await axios.put(`${API_URL}admin/customer/${customerId}/activate`, null, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    getBanners: async (token, activeFilter = 1) => {
        const response = await axios.get(`${API_URL}admin/banner`, {
            headers: {
                Authorization: `Bearer ${token}`,
                activeFilter: activeFilter
            }
        });
        return response;
    },

    createBanner: async (token, bannerData) => {
        const response = await axios.post(`${API_URL}admin/banner`, bannerData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    updateBanner: async (token, bannerData) => {
        const response = await axios.put(`${API_URL}admin/banner`, bannerData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    getTutorials: async (accessToken, activeFilter) => {
        const response = await axios.get(`${API_URL}admin/tutorial`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'activeFilter': activeFilter,
            }
        });
        return response;
    },

    getTutorial: async (accessToken, tutorialId) => {
        const response = await axios.get(`${API_URL}admin/tutorial/${tutorialId}`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    addTutorial: async (accessToken, tutorialData) => {
        const response = await axios.post(`${API_URL}admin/tutorial`, tutorialData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    updateTutorial: async (accessToken, tutorialData) => {
        const response = await axios.put(`${API_URL}admin/tutorial`, tutorialData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    getTutorialDocuments: async (accessToken, tutorialId) => {
        const response = await axios.get(`${API_URL}admin/tutorial/${tutorialId}/documents`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    addTutorialDocument: async (accessToken, tutorialId, documentData) => {
        const response = await axios.post(`${API_URL}admin/tutorial/${tutorialId}/document`, documentData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    },

    deactivateTutorialDocument: async (accessToken, documentId) => {
        const response = await axios.put(`${API_URL}admin/tutorial/document/${documentId}/deactivate`, null, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    activateTutorialDocument: async (accessToken, documentId) => {
        const response = await axios.put(`${API_URL}admin/tutorial/document/${documentId}/activate`, null, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    getDocumentPdf: async (accessToken, documentId) => {
        const response = await axios.get(`${API_URL}admin/tutorial/document/${documentId}/pdf`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            responseType: 'blob'
        });
        return response;
    },

    getOrders: async (accessToken, startDate, endDate, orderStatusId) => {
        const response = await axios.get(`${API_URL}admin/orders`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'startDate': startDate,
                'endDate': endDate,
                'orderStatusId': orderStatusId
            }
        });
        return response;
    },

    getCustomerSubscriptions: async (accessToken, startDate, endDate, filterBy) => {
        const response = await axios.get(`${API_URL}admin/customer-subscription`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'startDate': startDate,
                'endDate': endDate,
                'filterBy': filterBy
            }
        });
        return response;
    },

    getTutorialLogsReport: async (accessToken, startDate, endDate) => {
        const response = await axios.get(`${API_URL}admin/report/tutorial-log`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'startDate': startDate,
                'endDate': endDate
            }
        });
        return response;
    },

    getDashboardStats: async (accessToken) => {
        const response = await axios.get(`${API_URL}admin/dashboard/stats`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    getDashboardCustomerChart: async (accessToken, filter) => {
        const response = await axios.get(`${API_URL}admin/dashboard/customers/chart`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            params: { filter }
        });
        return response;
    },

    getDashboardRevenueChart: async (accessToken, filter) => {
        const response = await axios.get(`${API_URL}admin/dashboard/revenue/chart`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            params: { filter }
        });
        return response;
    },

    getDashboardRecentOrders: async (accessToken) => {
        const response = await axios.get(`${API_URL}admin/dashboard/orders/recent`, {
            headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        return response;
    },

    getDashboardUpcomingSessions: async (accessToken) => {
        const response = await axios.get(`${API_URL}admin/dashboard/sessions/upcoming`, {
            headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        return response;
    },

    getDashboardTutorialLogActivity: async (accessToken) => {
        const response = await axios.get(`${API_URL}admin/dashboard/tutorial-log/activity`, {
            headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        return response;
    },

    getDashboardRevenueBreakdown: async (accessToken, filter) => {
        const response = await axios.get(`${API_URL}admin/dashboard/revenue/breakdown`, {
            headers: { 'Authorization': `Bearer ${accessToken}` },
            params: { filter }
        });
        return response;
    },
    getTipsList: async (accessToken, activeFilter) => {
        const response = await axios.get(`${API_URL}admin/tips`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'activeFilter': activeFilter,
            }
        });
        return response;
    },

    getTips: async (accessToken, tipsId) => {
        const response = await axios.get(`${API_URL}admin/tips/${tipsId}`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    addTips: async (accessToken, tipsData) => {
        const response = await axios.post(`${API_URL}admin/tips`, tipsData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    updateTips: async (accessToken, tipsData) => {
        const response = await axios.put(`${API_URL}admin/tips`, tipsData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },
    getPregnancyJourneyList: async (accessToken, activeFilter) => {
        const response = await axios.get(`${API_URL}admin/pregnancy-journey`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'activeFilter': activeFilter,
            }
        });
        return response;
    },

    getPregnancyJourney: async (accessToken, journeyWeekId) => {
        const response = await axios.get(`${API_URL}admin/pregnancy-journey/${journeyWeekId}`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        return response;
    },

    addPregnancyJourney: async (accessToken, journeyData) => {
        const response = await axios.post(`${API_URL}admin/pregnancy-journey`, journeyData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },

    updatePregnancyJourney: async (accessToken, journeyData) => {
        const response = await axios.put(`${API_URL}admin/pregnancy-journey`, journeyData, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        return response;
    },
}

export default AdminService;